import React from "react";
import { motion } from "framer-motion";
import { GrShare } from "react-icons/gr";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Divider = ({ 
  text, 
  buttonText, 
  showImages = false, 
  icon: Icon = FaPhoneAlt,
  images = [] 
}) => {
  const navigate = useNavigate();

  const handleAction = () => {
    if (text === "Rent a Car near you by giving us a Call!!") {
      window.location.href = 'tel:+306941419012';
    } else if (text === "Check out all Rental Cars!") {
      navigate('/search');
    }
  };

  return (
    <motion.div 
      className="w-full bg-gradient-to-t from-rose-700 to-red-500 py-8 md:py-12 px-4 md:px-12 mb-12 shadow-2xl group overflow-hidden"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className={`flex flex-col lg:flex-row m-auto ${text === "Rent a Car near you by giving us a Call!!" ? "justify-around" : "justify-center"} items-center gap-6 max-w-[1440px] mx-auto`}>
        <motion.p 
          className="text-white font-bold font-mono text-2xl lg:text-3xl tracking-tight text-center lg:text-left max-w-[600px]"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {text === "Rent a Car near you by giving us a Call!!" ? (
            <>
              Rent a Car near you by giving us a{' '}
              <motion.span 
                className="group-hover:text-red-900 transition-colors duration-300"
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.2 }}
              >
                Call
              </motion.span>!!
            </>
          ) : (
            text
          )}
        </motion.p>
        
        {showImages && images.length > 0 && (
          <motion.div 
            className="flex flex-row items-center justify-center scale-75 md:scale-100"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 0.75 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            {images.map((img, index) => (
              <motion.img 
                key={index}
                src={img.src} 
                alt={img.alt}
                className={`${img.className} max-w-[200px] object-contain`}
                whileHover={{ scale: 1.1, rotate: 5 }}
                transition={{ duration: 0.2 }}
              />
            ))}
          </motion.div>
        )}

        <motion.button 
          onClick={handleAction}
          className="bg-gray-200 text-purple-900 text-center items-center font-normal font-mono text-sm md:text-md w-full md:w-auto px-6 md:px-12 p-2 rounded-2xl uppercase hover:bg-red-300 hover:text-purple-800 border-2 ease-in-out duration-300"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          whileTap={{ scale: 0.95 }}
        >
          <Icon className="inline-block mr-2 mb-0.5 text-center items-center m-auto" />
          {buttonText}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default Divider;
